import React, { useEffect, useState, useRef } from 'react'
import { connect } from 'react-redux'
import moment from 'moment'
import { alertActions, commonActions, certboxActions, chempSendboxActions } from '../../../../../store/actions'
import PdfViewer from '../../../../../module/pdf/PdfViewer'
import Alert from '../../../../../module/alert/Alert'

const ChempSndList = (props) => {

  const [isShowPdf, setIsShowPdf] = useState(false) //삭제 버튼 표시 여부
  const [showResponse, setShowResponse] = useState()
  const [showFileNm, setShowFileNm] = useState()
  const [blobResponse, setBlobResponse] = useState()
  const [docid, setDocid] = useState()
  const [crtCd, setCrtCd] = useState()
  const [brno, setBrno] = useState()
  const [oldYn, setOldYn] = useState()
  const [fileId, setFileId] = useState()
  const [printYn, setPrintYn] = useState()
  const [active, setActive] = useState()

  const tabIdRef = useRef()
  useEffect(() => {
    if (props.tabId !== tabIdRef.current) {
      tabIdRef.current = props.tabId
    }
  }, [props.tabId])
  
  //문서 구분코드
  useEffect(() => {
    if (!props.commoncode) return
  }, [props.commoncode])
  
  useEffect(() => {
    const fileList = props.sendboxInfo?.fileList

    if (!fileList) {
      //props.error({message: 'PDF 파일이 존재하지 않습니다.'});
      return
    }

    //commons.openPdf(fileList[0].fileId);
  }, [props.sendboxInfo])
  

  const makeStatusBtn = (status) => {
    switch (status) {
      case '10':
        return <span className="text-blue">발급완료</span>
        break
      case '11':
        return <span className="text-red">수취오류</span>
        break
      case '12':
        return <span className="text-green">수취완료</span>
        break
      default:
        return <span className="text-black">상태미정{status}</span>
    }
  }

  /**
   * pdf download
   * //TODO someday 상위 컴퍼넌트로 끌어올릴 것
   */
  let onPdfDown = (crtCd, docid, brno, fileObj) => {
    let fileList = []
    if (fileObj) {
      fileList.push(fileObj)
    }
    if (!fileList || !fileList.length) {
      props.error({ message: 'PDF 파일이 존재하지 않습니다.' })
      return
    }

    fileList.forEach((val, idx, arr) => {
      if (crtCd === '03' && fileList[idx].readYn === 'N') {
        const params = {
          docId: docid,
          fileId: fileList[idx].fileId,
          brno: brno,
        }
        props.getDownLoad(params)
      }

      setTimeout(() => {
        let url = process.env.REACT_APP_API_URL + '/portal/file/edms/' + fileList[idx].contentId
        let xhr = new XMLHttpRequest()
        xhr.responseType = 'blob'
        xhr.open('GET', url)
        xhr.send()
        xhr.onload = function () {
          if (xhr.status === 200) {
            // HTTP가 잘 동작되었다는 뜻.
            setShowResponse(window.URL.createObjectURL(xhr.response))
            setBlobResponse(xhr.response)
            setShowFileNm(val['originFileNm'])
            setIsShowPdf(true)
            setDocid(docid)
            setCrtCd(crtCd)
            setBrno(brno)
            setOldYn('N')
            setFileId(fileList[idx].fileId)
            setPrintYn(fileList[idx].printYn)
          } else {
            props.error({ message: 'PDF 파일이 존재하지 않습니다.' })
            return
          }
        }
      }, 1000)
    })
  }

  const eventHandler = (e, crtSeq) => {
    e.preventDefault()
    setActive(crtSeq)
  }

  // let styleTd = {
  //   cursor: 'pointer',
  // }

  const onShowOut = (e) => {
    e.preventDefault()
    setActive('')
  }

  return (
      <>
        <Alert />
        <div className="list-header">
          {/* <span className="total-num">계약서 목록 <em>123</em></span> */}
          <span className="total-num">
          현재페이지 <em>{props.pagingInfo?.currentPage}</em>/{props.pagingInfo?.totalPage} {props.pagingInfo?.totalRecords}건
        </span>
        </div>

        <div className="tbl-wrap mobile-scroll">
          <table className="tbl-list">
            <caption>선택, 신청방법, 증명서 및 발급번호, 발급처, 제출처, 발급일시, 최종이력, 상태, 열람 항목으로 구성</caption>
            <colgroup>
              <col style={{ width: '15%' }} />
              <col style={{ width: '20%' }} />
              <col style={{ width: '20%' }} />
              <col style={{ width: '15%' }} />
              <col style={{ width: '15%' }} />
              <col style={{ width: '10%' }} />
              <col />
            </colgroup>
            <thead>
            <tr>
              {/*<th scope="col">신청방법</th>*/}
              <th scope="col">
                <a
                    href="./"
                    onClick={(e) => {
                      e.preventDefault()
                      props.onSelected(e, 'srhOrder', 'DOCID')
                    }}
                >
                  증명서 및 발급번호
                </a>
              </th>
              {/*<th scope="col">*/}
              {/*  <a*/}
              {/*      href="./"*/}
              {/*      onClick={(e) => {*/}
              {/*        e.preventDefault()*/}
              {/*        props.onSelected(e, 'srhOrder', 'PRCHS_NM')*/}
              {/*      }}*/}
              {/*  >*/}
              {/*    발급처*/}
              {/*  </a>*/}
              {/*</th>*/}
              <th scope="col">
                <a
                    href="./"
                    onClick={(e) => {
                      e.preventDefault()
                      props.onSelected(e, 'srhOrder', 'RCV_MEMBER')
                    }}
                >
                  제출처
                </a>
              </th>
              <th scope="col">업체명</th>
              <th scope="col">
                <a
                    href="./"
                    onClick={(e) => {
                      e.preventDefault()
                      props.onSelected(e, 'srhOrder', 'ISSUEDT')
                    }}
                >
                  발급일시
                </a>
              </th>
              <th scope="col">
                <a
                    href="./"
                    onClick={(e) => {
                      e.preventDefault()
                      props.onSelected(e, 'srhOrder', 'MOD_DT')
                    }}
                >
                  최종이력
                </a>
              </th>
              <th scope="col">
                <a
                    href="./"
                    onClick={(e) => {
                      e.preventDefault()
                      props.onSelected(e, 'srhOrder', 'STS')
                    }}
                >
                  상태
                </a>
              </th>
              <th scope="col">열람</th>
            </tr>
            </thead>
            <tbody>
            {props.data?.length > 0 ? (
                props.data?.map((sendboxObj, index) => (
                    <tr key={index}>
                      {/*<td onClick={() => props.onSentDetail(contractObj)} className="cursor">*/}
                      {/*  {contractObj.docType}*/}
                      {/*</td>*/}
                      <td>
                        {sendboxObj.crtNm}
                        <span className="txt1">{sendboxObj.docid}</span>
                      </td>
                      {/*<td>*/}
                      {/*  {sendboxObj.prchsNm}*/}
                      {/*</td>*/}
                      <td>
                        {sendboxObj.rcvMember}
                      </td>
                      <td>
                        {sendboxObj.orgnm}
                      </td>
                      <td>
                        {sendboxObj.issuedt === null ||
                        moment(sendboxObj?.issuedt, 'YYYYMMDDHHmmss').format('YYYY.MM.DD HH:mm:ss') === 'Invalid date'
                            ? '-'
                            : moment(sendboxObj?.issuedt, 'YYYYMMDDHHmmss').format('YYYY.MM.DD HH:mm:ss')}
                      </td>
                      <td>
                        {sendboxObj.modDt === null || moment(sendboxObj.modDt).format('YYYY.MM.DD HH:mm:ss') === 'Invalid date'
                            ? '-'
                            : moment(sendboxObj.modDt).format('YYYY.MM.DD HH:mm:ss')}
                      </td>
                      <td>
                        {makeStatusBtn(sendboxObj?.sts)}
                      </td>
                      <td>
                        {sendboxObj.fileGroupId !== null && sendboxObj.fileNewList?.length !== 0 && sendboxObj.fileNewList?.length === 1 && (
                            <div className="attach-wrap">
                              {sendboxObj.fileNewList?.map((fileObj, index) => (
                                  <a
                                      key={index}
                                      className="attach attach-link"
                                      onClick={(e) => {
                                        e.preventDefault()
                                        onPdfDown(sendboxObj.crtCd, sendboxObj.docid, sendboxObj.brno, fileObj)
                                        return
                                      }}
                                  >
                                    첨부
                                  </a>
                              ))}
                            </div>
                        )}
                        {sendboxObj.fileGroupId !== null && sendboxObj.fileNewList?.length !== 0 && sendboxObj.fileNewList?.length !== 1 && (
                            <div className="attach-wrap">
                              <a
                                  href="#"
                                  className="attach attach-link"
                                  onClick={(e) => eventHandler(e, sendboxObj.crtSeq + index)}
                                  aria-expanded={active === sendboxObj.crtSeq + index ? 'true' : 'false'}
                                  aria-controls={sendboxObj.crtSeq + index}
                                  aria-disabled={active === sendboxObj.crtSeq + index ? 'true' : 'false'}
                              >
                                첨부
                              </a>
                              <ul
                                  id={sendboxObj.crtSeq + index}
                                  className={active === sendboxObj.crtSeq + index ? 'attach-file active' : 'attach-file'}
                              >
                                {sendboxObj.fileNewList?.map((fileObj, index) => (
                                    <li key={index}>
                                      <a
                                          onClick={(e) => {
                                            e.preventDefault()
                                            onPdfDown(sendboxObj.crtCd, sendboxObj.docid, sendboxObj.brno, fileObj)
                                            onShowOut(e)
                                            return
                                          }}
                                      >
                                        {fileObj.originFileNm}
                                      </a>
                                    </li>
                                ))}
                              </ul>
                            </div>
                        )}
                        {sendboxObj.fileGroupId === null && '-'}
                      </td>
                    </tr>
                ))
            ) : (
                <tr>
                  <td className="center" colSpan={7}>
                    <div className="nodata">조회 결과가 없습니다.</div>
                  </td>
                </tr>
            )}
            </tbody>
          </table>
        </div>
        {isShowPdf === true && (
            <PdfViewer
                blobResponse={blobResponse}
                showResponse={showResponse}
                fileNm={showFileNm}
                crtCd={crtCd}
                docid={docid}
                brno={brno}
                oldYn={oldYn}
                fileId={fileId}
                printYn={printYn}
                onClose={() => setIsShowPdf(false)}
            />
        )}
      </>
  )
}

const mapStateToProps = (state) => {
  return {
    sendboxInfo: state.chempSendbox?.sendboxInfo,
    sumitCd: state.commoncode?.co?.CRT_SUBMIS_TP,
    isFailure: state.chempSendbox?.isFailure,
  }
}

const actionCreators = {
  changeSearchInfo: chempSendboxActions.changeSearchInfo,
  success: alertActions.success,
  readSendboxList: chempSendboxActions.readSendboxList,
  getCommonCode: commonActions.getCommonCode,
  confirm: alertActions.confirm,

  getDownLoad: certboxActions.getDownLoad,
}

export default connect(mapStateToProps, actionCreators)(ChempSndList)
